import {Card, CardBody, CardHeader, GridItem, Heading, LinkBox, SimpleGrid, Text} from "@chakra-ui/react";
import {BarWithDeals, ChainWithDeals, sortedDealsNullable} from "../../interfaces/Bar";
import {LinkOverlayToDealOwner} from "./LinkOverlayToDealOwner";
import {useTranslations} from "next-intl";
import {IDeal} from "../../interfaces/IDeal";
import DealView from "./DealView";
import {groupDeals} from "../tools/groupDeals";
import {DealGroupLocationList} from "./LocationBadge";
import {findFreshest} from "../tools/latestUpdate";

export default function ChainCard({chain, bars}: {chain: ChainWithDeals, bars: BarWithDeals[]}) {
    const tChain = useTranslations("chain")
    return (
        <LinkBox>
            <Card variant="elevated" size="sm">
                <LinkOverlayToDealOwner owner={chain}>
                    <CardHeader>
                        <Heading size="md">{chain.name}</Heading>
                        {chain.description && <Text as="i">{chain.description}</Text>}
                        <Text>{tChain("chain_title", {num: bars.filter(b => b.chain?.id == chain.id).length})}</Text>
                    </CardHeader>
                    <CardBody>
                        <SimpleGrid spacing={5} minChildWidth="200px" justifyContent="stretch" alignItems="stretch">
                            {sortedDealsNullable(chain)?.map((deal: IDeal) =>
                                <DealView stretch={true} key={deal.description} deal={deal} updatedAt={chain.updated_at}/>
                            )}
                            {
                                groupDeals(bars.filter(b => b.chain?.id == chain.id)).map(dg => (
                                    <GridItem key={dg.deal.id} colSpan="auto">
                                        <DealView stretch={true} deal={dg.deal} h="100%" badge={(
                                            <DealGroupLocationList dealGroup={dg} chain={chain}/>
                                        )} updatedAt={findFreshest(dg.bars)}/>
                                    </GridItem>
                                ))
                            }
                        </SimpleGrid>
                    </CardBody>
                </LinkOverlayToDealOwner>
            </Card>
        </LinkBox>
    )
}